
import "./CartDrawer.css"
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, clearCart, decreaseFromCart, removeFromCart } from '../../redux/state/cart/CartSlice';
import { NavLink } from 'react-router-dom';

const CartDrawer = ({ isCartOpen, toggleCart }) => {

  const cart = useSelector(state => state.cart)
  const dispatch = useDispatch();

  return (
    <>
      {/* Overlay background */}
      <div
        className={`cart-overlay ${isCartOpen ? 'show' : ''}`}
        onClick={toggleCart}
      ></div>

      {/* Drawer */}
      <div className={`shopping-cart modern-drawer ${isCartOpen ? 'open' : ''}`}>

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center p-3 shadow-sm border-bottom bg-white">
          <h5 className="fw-bold mb-0">🛒 Your Cart</h5>
          <button className="btn-close" onClick={toggleCart}></button>
        </div>

        {/* ITEM COUNT & CLEAR BUTTON */}
        <div className="d-flex justify-content-between align-items-center px-3 py-2 bg-light border-bottom">
          <span className="text-secondary">
            Items in cart: <strong className="text-dark">{cart.cartTotalItems}</strong>
          </span>

          <button
            className="btn btn-sm btn-outline-danger rounded-pill px-3"
            onClick={() => dispatch(clearCart())}
          >
            Clear
          </button>
        </div>

        {/* CART ITEMS */}
        <div className="cart-items-area p-3">

          {cart.cartItems.length === 0 ? (
            <div className="text-center py-5">
             🛒
              <p className="mt-2 text-secondary">Your cart is empty</p>
            </div>
          ) : (
            cart.cartItems.map(cartItem => (
              <div
                key={cartItem.id}
                className="d-flex align-items-center justify-content-between py-2 border-bottom cart-item"
              >

                {/* Qty controls */}
                <div className="qty-box text-center">
                  <button className="qty-btn" onClick={() => dispatch(addToCart(cartItem))}>
                    +
                  </button>
                  <small className="d-block">{cartItem.cartQuantity}</small>
                  <button className="qty-btn" onClick={() => dispatch(decreaseFromCart(cartItem))}>
                    –
                  </button>
                </div>

                {/* Image */}
                <img src={process.env.REACT_APP_IMAGEBASE_URL + 'products/' + cartItem.image} alt={cartItem.image} className="cart-thumb"/>

                {/* Product Info */}
                <div className="ms-2 flex-grow-1">
                  <h6 className="mb-0">{cartItem.product_name}</h6>
                  <small className="text-muted">৳ {cartItem.discountedPrice}</small>
                </div>

                {/* Total price */}
                <strong className="me-3">৳ { cartItem.discountedPrice * cartItem.cartQuantity }</strong>

                {/* Remove */}
                <p
                  className="btn-close text-danger m-0"
                  onClick={() => dispatch(removeFromCart(cartItem))}
                ></p>
              </div>
            ))
          )}
        </div>

        {/* FOOTER */}
        <div className="p-3 border-top bg-white">
          <div className="d-flex justify-content-between mb-3">
            <strong>Subtotal:</strong>
            <strong className="fs-5">৳ {cart.cartSubTotalAmount}</strong>
          </div>

          <NavLink
            to="/checkout"
            className="btn btn-dark w-100 rounded-pill py-2"
            onClick={toggleCart} // close cart when navigating
          >
            Proceed to Checkout
          </NavLink>
        </div>
      </div>
    </>
  )
}

export default CartDrawer;
